import { render, staticRenderFns } from "./eventOrders.vue?vue&type=template&id=ff45e862&scoped=true&"
import script from "./eventOrders.vue?vue&type=script&lang=js&"
export * from "./eventOrders.vue?vue&type=script&lang=js&"
import style0 from "./eventOrders.vue?vue&type=style&index=0&id=ff45e862&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff45e862",
  null
  
)

export default component.exports